import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <h2 className="section-title">专题合集</h2>
        <p className="section-subtitle">按类型和阅读偏好分类的漫画合集入口，快速找到你想看的内容</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {indexItems.map((item) => (
            <a
              key={item.id}
              href="#index"
              onClick={(e) => e.preventDefault()}
              className="group flex flex-col items-center p-5 bg-background-100 rounded-xl border border-background-200 comic-card-hover cursor-pointer text-center"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-200 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-950 mb-1 whitespace-nowrap">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-2 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
              <span className="text-xs font-medium text-primary-600 whitespace-nowrap">
                {item.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}